import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon, XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Evaluaciones inconsistentes', 'Seguimientos poco claros', 'Dificultad para medir avances', 'Pérdida de tiempo constante', 'Pacientes que abandonan', 'Ingresos estancados'];
  return <section className="py-10 px-4 bg-slate-900 border-y border-slate-800" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-74">
          <div className="flex items-center gap-2 mb-3" data-id="element-75">
            <AlertOctagon className="w-6 h-6 text-red-500" data-id="element-76" />
            <h2 className="text-xl md:text-3xl font-bold text-white" data-id="element-77">
              El problema que nadie te dice
            </h2>
          </div>

          <p className="text-sm text-slate-300 mb-2" data-id="element-78">
            No es que no sepas. No es que te falte experiencia.
          </p>
          <p className="text-base font-bold text-amber-400 mb-4 border-l-4 border-amber-500 pl-3" data-id="element-79">
            👉 Nunca te enseñaron a trabajar con un sistema.
          </p>

          <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-80">
            {problems.map((problem, index) => <div key={index} className="flex items-center gap-1.5 bg-slate-950 p-2 rounded-lg border border-slate-800" data-id="element-81">
                <XCircle className="w-3.5 h-3.5 text-red-500 flex-shrink-0" data-id="element-82" />
                <span className="text-slate-200 text-xs font-medium" data-id="element-83">
                  {problem}
                </span>
              </div>)}
          </div>

          <div className="bg-red-950/30 border border-red-900/50 p-3 rounded-lg" data-id="element-84">
            <p className="text-sm font-bold text-white" data-id="element-85">
              👉 Trabajás mucho… pero avanzás poco.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}